<template>
    <div >
        <Breadtabsheader/>
        <div class="h-content">
            <!-- 搜素条件 -->
            <div class="h-piece">
                <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
                    <div class="h-thirdColumn w-newColumn">
                        <el-form-item label="产品编码/名称" prop="materialCodeNameLike">
                            <el-input v-model="q.prodCodeNameLike" placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="工艺人编码/姓名">
                            <el-input v-model="q.userNameLike" :clearable="true"></el-input>
                        </el-form-item>
                        <el-form-item label="产品大类">
                            <brselectlazy category="product_level" :v="q.oneLid" v-model="q.oneLid"
                                          :clearable="true"
                                          style="width:100%"/>
                        </el-form-item>

                    </div>
                </el-form>
                <div class="l-screenBox">
                    <div class="l-retrieval">
                        <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
                        <el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置
                        </el-button>
                        <el-button
                                class="h-btn h-formBtn h-bggreen" icon="el-icon-plus"
                                @click="openGy" >新增工艺审批人
                        </el-button>
                    </div>
                </div>
            </div>

            <div class="h-table h-mrt30">
                <el-table
                        ref="ddtable"
                        :data="tableData"
                        @selection-change="handleSelectionChange"
                        stripe
                        border
                        style="width: 100%">

                    <el-table-column
                        type="selection"
                        fixed
                        width="40">
                    </el-table-column>
                    <el-table-column
                        type="index"
                        width="40"
                        label="序号"
                        fixed >
                    </el-table-column>

                    <el-table-column
                        prop="prodcode"
                        label="产品编码"
                        width="110">
                    </el-table-column>
                    <el-table-column
                        prop="promodel"
                        label="产品名称"
                        width="150">
                    </el-table-column>
                    <el-table-column
                        prop="fourcode"
                        label="产品层级"
                        width="150">
                    </el-table-column>
                    <el-table-column
                        prop="userCode"
                        label="工艺人编码"
                        width="110">
                    </el-table-column>
                    <el-table-column
                        prop="userName"
                        label="工艺人名称"
                        width="150">
                    </el-table-column>
                    <el-table-column
                            prop="oneLid"
                            label="产品大类编码"
                            width="110">
                    </el-table-column>
                    <el-table-column
                            prop="prodseries"
                            label="产品大类名称"
                            width="110">
                    </el-table-column>

                    <el-table-column
                            prop="remark"
                            label="备注"
                            width="110">
                    </el-table-column>

                    <el-table-column
                            prop="cucode"
                            label="创建人编码"
                            width="110">
                    </el-table-column>
                    <el-table-column
                            prop="cuname"
                            label="创建人名称"
                            width="110">
                    </el-table-column>
                    <el-table-column
                            prop="cdate"
                            :formatter="formatDate"
                            label="创建时间"
                            width="110">
                    </el-table-column>
                    <el-table-column
                            prop="lucode"
                            label="修改人编码"
                            width="110">
                    </el-table-column>
                    <el-table-column
                            prop="ldate"
                            :formatter="formatDate"
                            label="最后修改时间"
                            width="110">
                    </el-table-column>


                    <el-table-column
                            fixed="right"
                            label="操作"
                            width="280" >
                        <template slot-scope="scope">
                            <div style="text-align: left;">
                                <el-button
                                        type="text"
                                        size="small"
                                        @click="toChange(scope.row)"
                                        class="h-tableLink h-btn"  >

                                    编辑
                                </el-button>
                                <el-button
                                        size="small" class="h-tableLink h-btn"
                                        @click="doDelete(scope.row)">删除
                                </el-button>
                            </div>
                        </template>


                    </el-table-column>
                </el-table>
                <div class="h-tableB h-mrt30">
                    <div class="h-tableBL">
                        <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                                   @click="exportExcel">批量导出
                        </el-button>
                        <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-export"
                                   @click="uploaddownexcelflagbtn">批量导入
                        </el-button>
                        <uploaddownexcel
                            :visible.sync="uploaddownexcelflag"
                            v-if="uploaddownexcelflag"
                            clsname="bscSpecificGyExcel"
                            :startrow="1"
                            @callback="uploadExcelFilecallback"/>

                    </div>
                    <div class="h-pagination2">
                        <pagination :page="q" @query="query" />
                    </div>
                </div>

            </div>
        </div>
        <el-dialog :close-on-click-modal="false" :visible.sync="createGyVisible" class="h-dialog2 wuliu">
            <div class="h-dialogImg">
                <div class="h-disTable">
                    <div class="h-tableCell">
                        <h1>新增工艺审核人</h1>
                    </div>
                </div>
            </div>
            <div class="h-formLine">
                <el-form  ref="gyForm" :model="add" :inline="true" :rules="checkGy"  class="demo-ruleForm h-formbLine h-dialogForm">

                    <el-form-item label="产品编码" class="h-elformWrap-2" prop="prodcode">
                        <el-input    v-model="add.prodcode"  @change="selectByCode"  placeholder="请输入" />
                    </el-form-item>
                    <el-form-item label="产品型号" class="h-elformWrap-2" prop="promodel">
                        <el-input     v-model="add.promodel"  placeholder="输入产品编码自动带出"  disabled />
                    </el-form-item>
                    <el-form-item label="产品大类名称" class="h-elformWrap-2" prop="prodseries">
                        <el-input placeholder="输入产品编码自动带出" v-model="add.prodseries" readonly></el-input>
                    </el-form-item>
                    <el-form-item label="产品大类编码" class="h-elformWrap-2" prop="oneLid">
                        <el-input placeholder="输入产品编码自动带出" v-model="add.oneLid" readonly></el-input>
                    </el-form-item>
                    <el-form-item label="工艺审核人编码" class="h-elformWrap-2"  prop="userCode">
                        <el-input placeholder="请输入工号" v-model="add.userCode" oninput="value=value.replace(/[^\d]/g, '')" @change="checkUser"></el-input>
                    </el-form-item>
                    <el-form-item label="工艺审核人名称" class="h-elformWrap-2" prop="userName">
                        <el-input placeholder="输入工号自动带出" v-model="add.userName" readonly></el-input>
                    </el-form-item>
                    <el-form-item label="备注" class="h-elformWrap-1"  prop="remark">
                        <el-input v-model="add.remark" style="width: 84%;"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancelGy">取 消</el-button>
                <el-button type="primary" @click="submitGy">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import ss from '../../../api/SystemService';
    import updownfile from "../../../utils/updownfile";
    import specificGy from "@/api/loud/yuce/specificGy";
    import uploaddownexcel from "@/components/uploaddown/uploaddownexcel.vue";

    export default {
        components: {uploaddownexcel},
        data() {
            return {
                //导入Excel
                uploaddownexcelflag: false,
                //查询属性
                q: {
                    prodCodeNameLike: null,
                    userNameLike: null,
                    oneLId: null,
                    delflag:1,
                    pageSize:10,
                    pageNo:1,
                    total:0,
                },
                //表单
                add:{
                    id:null,
                    prodcode:null,//产品编码
                    promodel:null,//产品名称
                    userCode:null, //
                    userName:null, //
                    prodseries:null,
                    oneLid:null,
                    fourcode:null,
                    remark:null,
                },

                tableData: [],
                LevelName: [],
                createGyVisible :false,

                checkGy: {

                    prodcode:[{required: true, message: '产品编码必填', trigger: 'blur'}],
                    promodel:[{required: true, message: '产品型号必填', trigger: 'blur'}],
                    userCode:[{required: true, message: '用户编码必填', trigger: 'blur'}],
                    userName:[{required: true, message: '用户姓名必填', trigger: 'blur'}],

                },
            }
        },
        created() {
            this.query();
            this.showLevelName();
        },
        methods: {
            query() {
                ss.specificGy.selecPage(this.q).then(rd=>{
                    this.q.total = rd.total;
                    this.tableData = rd.records;
                })
            },
            handleFilter() {
                this.query();
            },

            handleSelectionChange(lists){
                this.tableSelectedList = lists;
            },
            resetData(){
                var pageSize=this.q.pageSize;
                var pageNo=this.q.pageNo;
                var total=this.q.total;
                this.q= {
                    prodCodeNameLike: null,
                    userNameLike: null,
                    oneLId: null,
                    pageSize: pageSize,
                    pageNo: pageNo,
                    total:total,
                }
            },
            //取消
            cancelGy(){
                this.createGyVisible = false;
                this.add = {};
            },
            //提交
            submitGy(){
                this.$refs['gyForm'].validate((valid) => {
                    if (valid) {
                        ss.specificGy.save(this.add).then(rd => {
                            this.$msg.msgs(rd.msg);
                            this.createGyVisible = false;
                            this.add = {};
                            this.query();
                        });
                    } else {
                        this.$msg.msge("请完善信息后再提交！");
                        return false;
                    }
                });
            },


           //新增工艺
            openGy() {
                this.add = {};
                this.createGyVisible = true;
            },
            toChange(row){
                ss.specificGy.selectById(row.id).then(rd => {
                    this.add = rd.obj;
                });

                this.createGyVisible = true;
            },

            //删除
            doDelete(row){
                this.$msg.confirm("确认删除?", () => {
                    ss.specificGy.deleteById(row.id).then(rd => {
                        this.$msg.msgs(rd.msg);
                        this.query();
                    });
                });

            },
            //查询所有产品大类
            showLevelName() {
                ss.UserDemand.showLevelName().then(rd => {
                    this.LevelName = rd;
                })
            },
            //根据根据编码查询物料信息
            selectByCode(code) {
                var data = {};
                data.materialCode = code;
                ss.chanpin.selectListByCode(data).then(rd => {
                    if(rd){
                        this.add.promodel = rd.materialDescrition;
                        this.add.fourcode = rd.productHierarchy;
                        for (var i = 0; i < this.LevelName.length; i++) {

                            if (rd.productHierarchy.startsWith(this.LevelName[i].id)){
                                this.add.oneLid = this.LevelName[i].id;
                                this.add.prodseries = this.LevelName[i].levelname;
                            }
                        }
                    }else{
                        this.$msg.msge("产品编码错误！");
                        this.add.promodel = '';
                        this.add.oneLid ='';
                        this.add.prodseries ='';
                    }
                    this.$forceUpdate();
                })

            },

            //检查用户是否存在
            checkUser(code){
                ss.UserService.selectById(code).then(rd => {
                    if(rd.obj==null){
                        this.$msg.msge("该用户在系统中不存在！");
                        this.add.userCode ='';
                        this.add.userName ='';
                    }else{
                        this.$set(this.add, 'userName', rd.obj.username);//产品编码

                    }

                })
            },
            //格式化时间
            formatDate(row, column) {
                // 获取单元格数据
                let data = row[column.property]
                if(data == null || data == '') {
                    return null
                }
                let dt = new Date(data)
                return this.$util.riQi3(dt);
            },
            //导出
            exportExcel(){
                this.q.ids=  _.join(_.map(this.tableSelectedList,"id"),",");
                updownfile.down("api/swyl/v1/reform/bscSpecificGy/downloadExcel", this.q, "get");
            },
            //导入Excel
            uploaddownexcelflagbtn() {
                this.uploaddownexcelflag = true;
            },
            uploadExcelFilecallback(rd) {
                this.query();
                this.$msg.msgs(rd.msg);
            },
        }
    }
</script>
